import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/FileJpg.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: i }));
o.displayName = "FileJpgIcon";
const c = o;
export {
  c as FileJpg,
  o as FileJpgIcon
};
